import axios from 'axios';

const debug_mode = false;
var SERVER_URL = "";
if (debug_mode) {
  // SERVER_URL = "http://localhost:8080";
  SERVER_URL = "https://central.nau.synology.me";
}

const api = axios.create({
    baseURL: SERVER_URL,
    withCredentials: true
});
export default api;